import type { Tag, TagColor } from './tagging.types'

export const resolveSubmitColor = (
  inputText: string,
  selectedColor: TagColor,
  orgTags: Tag[],
): TagColor => {
  const trimmed = inputText.trim().toLowerCase()

  if (!trimmed) {
    return selectedColor
  }

  const exactMatch = orgTags.find(t => t.name.toLowerCase() === trimmed)

  return exactMatch ? exactMatch.color : selectedColor
}
